<template>
    <div class="recived-account default-wrap">
        <div class="wrap">
            <div class="wallet-tool-bar">
                <div class="filter">
                    <rent-select refName="bankCard" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="">所有狀態</li>
                            <li data-id="NORMAL">審核通過</li>
                            <li data-id="REJECT">審核失敗</li>
                            <li data-id="UNDER_REVIE">審核中</li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <new-bank :bankCardState="filter.bankCardState" @clearFilterEvent="clearFilter()"></new-bank>
        </div>
    </div>
</template>
<script>
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import newBank from '@/components/bussiness/settingCenter/wallet/reciveAccount/newBank.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            isDefault: false,
            filter: {
                bankCardState: null
            }
        }
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false
            if( value.ref == 'bankCard' ){
                this.filter.bankCardState = value.id
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        clearFilter: function () {
            this.isDefault = true
            this.filter.bankCardState = null
        }
    },
    computed: {
        ...mapGetters({
            verifiedState: 'GET_USER_STATUS',
            userBalance: 'GET_USER_BALANCE',
        })
    },
    components: {
        RentSelect,
        newBank,
    }
}
</script>
<style lang="scss" scoped>
    .recived-account{
        .wrap{
            .wallet-tool-bar{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;
                .filter{
                    display: flex;
                    .biz-rent-select{
                        width: 216px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/wallet/reciveAccount/reciveAccountComp.vue